import type { ProductPageQuery, ProductPage } from '@/shared/apollo-api/__generated__/types';
import type { IProduct } from '../models/product';
import type { IPhoto } from '../models/slider';

import { mapVat } from './product-to-sku-list';

export const productMapper = (product: ProductPageQuery['product']): IProduct => {
  return {
    id: product.id,
    rating: product.rating || 0,
    externalRating: product.externalRating || false,
    // @ts-ignore
    badges: product.badges,
    attributes: product.attributes,
    shortDescription: product.shortDescription || '',
    ordersAmount: product.ordersQuantity,
    adultCategory: false,
    offer: null,
    comboDiscountPrice: undefined,
    video: product.video?.url,
    characteristics: product.characteristics,
    category: product.category!,
    categoryId: product.category!.id,
    circularPhotos: product.photo360 || [],
    circularPhotosList:
      product.photo360?.map((photo) => ({
        photo: {
          '360': photo.link,
        },
        photoKey: photo.key,
      })) || [],
    colorPhotoPreview: false,
    description: product.description,
    photos: ProductMapperHelper.mapPhotos(product.photos),
    seller: product.shop
      ? {
          ...product.shop,
          link: product.shop.url,
          currentCategory: null,
          appliedFilters: null,
          filters: null,
          totalProducts: null,
          category: null,
          categoryTree: null,
          parents: null,
          avatar: product.shop.avatar?.low,
        }
      : null,
    skuList: product.skuList.map((sku) => ({
      ...sku,
      purchasePrice: sku.sellPrice,
      fullPrice: sku.fullPrice,
      vat: mapVat(sku.vat!),
      paymentOptions: sku.paymentOptions,
    })),
    /** проверка на неразрывные пробелы */
    title: product.title.replace(/\u00A0/g, ' '),
    totalAvailableAmount: product.skuList.reduce((sum, sku) => sku.availableAmount + sum, 0),
    productOptionDtos: undefined,
    feedbackQuantity: product.feedbackQuantity || 0,
    comments: product.comments.map((comment) => ({
      commentType: comment.type,
      comment: comment.value,
    })),
    cardNearestDeliveryInfo: product.cardNearestDeliveryInfo,
  };
};

export class ProductMapperHelper {
  static mapPhotos(photos: ProductPageQuery['product']['photos']): IPhoto[] {
    return photos.map((photo) => ({
      high: photo.link.high,
      // TODO: what? research this https://track.magnit.ru/browse/B2CFRONT-5841
      // @ts-ignore
      low: photo.link.low,
      original: photo.original?.high,
      thumbnail: photo.thumbnail?.low,
      photoKey: photo.key,
    }));
  }
}
